var _rect, _rect2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendsIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_330_4233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 11H11V33H33V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_330_4233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 13.75C27.7389 13.75 26.8211 15.9473 28.083 17.2477L25.132 23.3769C24.8136 23.3712 24.528 23.4328 24.2571 23.5532L21.224 20.877C21.6248 19.5474 20.6263 18.2188 19.2498 18.2188C17.613 18.2188 16.6345 20.036 17.5188 21.4004L14.7174 25.8024C13.4558 25.6304 12.3745 26.6118 12.3745 27.8436C12.3745 28.9827 13.298 29.906 14.4371 29.906C16.0741 29.906 17.0518 28.0886 16.168 26.7244L18.9694 22.3223C19.3728 22.3773 19.7442 22.3174 20.0863 22.1653L23.1193 24.8414C22.7193 26.1682 23.7144 27.4999 25.0937 27.4999C26.8475 27.4999 27.7858 25.4518 26.6811 24.1211L29.6919 17.8684C30.7703 17.8013 31.625 16.9078 31.625 15.8125C31.625 14.6734 30.7016 13.75 29.5625 13.75Z",
    fill: "#7a7a7a",
    stroke: "#7a7a7a",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendsIconNew);
export default __webpack_public_path__ + "static/media/trendsIconNew.6eed1b8f.svg";
export { ForwardRef as ReactComponent };